import styled, { css } from 'styled-components';
import { borderRadius, colorUsage, getSpacing, shadow, transitionDuration, zIndex } from 'stylesheet';
import { Pen, Trash } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "EditLinkToolbarstyle__Container",
  componentId: "sc-8z2muo-0"
})(["position:absolute;z-index:", ";display:grid;grid-template-areas:'title delete' 'link-url edit';grid-template-rows:auto auto;grid-template-columns:auto auto;align-items:center;margin-bottom:", ";padding:", " ", ";column-gap:", ";background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";transition:bottom ", ",left ", ";"], zIndex.WYSIWYGToolbar + 1, getSpacing(2), getSpacing(1), getSpacing(2), getSpacing(1), colorUsage.pageForeground, colorUsage.linkToolbarBorder, borderRadius.medium, shadow.bottom.light, transitionDuration["default"], transitionDuration["default"]);
var Title = styled.p.withConfig({
  displayName: "EditLinkToolbarstyle__Title",
  componentId: "sc-8z2muo-1"
})(["grid-area:title;text-overflow:ellipsis;"]);
var iconStyle = css(["justify-self:center;height:14px;cursor:pointer;& path{fill:", ";}&:hover path{fill:", ";}"], colorUsage.defaultIconColor, colorUsage.iconGradientHoverForeground);
var Delete = styled(Trash).withConfig({
  displayName: "EditLinkToolbarstyle__Delete",
  componentId: "sc-8z2muo-2"
})(["grid-area:delete;", ""], iconStyle);
var Edit = styled(Pen).withConfig({
  displayName: "EditLinkToolbarstyle__Edit",
  componentId: "sc-8z2muo-3"
})(["grid-area:edit;", ""], iconStyle);
export { Container, Title, Delete, Edit };